import(/* webpackMode: "eager" */ "/home/runner/_work/nvs-code/nvs-code/web/app/error.tsx");
